
export default {
  name: 'icon-registration',
};
